$(document).ready(function() {

    // Abgeordneten Liste
    var langFile, table, abgeordnetenListe;

    var setDropdowns = function() {
        var parteien = [];
        var wahlkreise = [];
        var bezirke = [];
        var parteienDD = $('<select title="Fraktion" id="partei" />');
        var wahlkreiseDD = $('<select title="Wahlkreis" id="wahlkreis" />');
        var bezirkeDD = $('<select title="Bezirk" id="bezirk" />');
        $('#abgeordneten-liste').find('.list li').each(function() {
            parteien.push($(this).find('div[data-sort="partei"] span.partei').html());
            wahlkreise.push($(this).find('div[data-sort="wahlkreis"] span.wahlkreis').html());
            bezirke.push($(this).find('div[data-sort="bezirk"] span.bezirk').html());
        });

        var alleParteien = parteien;
        var parteienAmount = {};

        // Ermittle Anzahl je Partei
        $.each(alleParteien, function(index, value) {
            var element = alleParteien[index];
            if (parteienAmount[element]) {
                parteienAmount[element] += 1;
            } else {
                parteienAmount[element] = 1;
            }
        });

        // Sortiere Parteien nach Anzahl aufsteigend
        var parteienSortedTmp = Object.keys(parteienAmount).sort(function(a, b) {
            return parteienAmount[a] - parteienAmount[b];
        });

        // Reverse um die Partei mit den meisten Mitglieder zuerst zu bekommen
        var parteienSorted = parteienSortedTmp.reverse();

        wahlkreise = wahlkreise.filter(unique);
        bezirke = bezirke.filter(unique);
        wahlkreise.sort();
        bezirke.sort();

        parteienDD.append($('<option value="">Alle Fraktionen</option>'));
        $.each(parteienSorted, function(index, value) {
            parteienDD.append($('<option value="' + value + '">' + value + '</option>'));
        });
        wahlkreiseDD.append($('<option value="">Alle Wahlkreise</option>'));
        $.each(wahlkreise, function(index, value) {
            wahlkreiseDD.append($('<option value="' + value + '">' + value + '</option>'));
        });
        bezirkeDD.append($('<option value="">Alle Bezirke</option>'));
        $.each(bezirke, function(index, value) {
            bezirkeDD.append($('<option value="' + value + '">' + value + '</option>'));
        });

        $('.partei-dropdown').append(parteienDD);
        $('.wahlkreis-dropdown').append(wahlkreiseDD);
        $('.bezirk-dropdown').append(bezirkeDD);

    };

    if ($('div#abgeordneten-liste').length > 0) {

        setDropdowns();

        abgeordnetenListe = new List('abgeordneten-liste', {
            valueNames: ['name', 'partei', 'wahlkreis', 'bezirk'],
            page: 10,
            pagination: [{
                outerWindow: 1
            }]
        }).on('updated', function(list) {
            if (list.matchingItems.length == 0) {
                $('.headings-wrapper').hide();
                $('.no-results').show();
            } else {
                $('.no-results').hide();
                $('.headings-wrapper').show();
            }

            setTimeout(function() {
                $(".pagination li.active").attr("aria-current", true);
                $(".pagination li.active a").contents().unwrap();
                $(".pagination li.disabled a").contents().unwrap();
            }, 200);

        });

        updateList();

        $('#abgeordneten-liste').on('change', '#partei, #wahlkreis, #bezirk', function() {
            updateList();
        });

    }

    function updateList() {
        var valPartei = $("select#partei").val();
        var valWahlkreis = $("select#wahlkreis").val();
        var valBezirk = $("select#bezirk").val();
        abgeordnetenListe.filter(function(item) {
            var parteiFilter = false;
            var wahlkreisFilter = false;
            var bezirkFilter = false;

            if (valPartei == '') {
                parteiFilter = true;
            } else {
                parteiFilter = item.values().partei == valPartei;
            }
            if (valWahlkreis == '') {
                wahlkreisFilter = true;
            } else {
                wahlkreisFilter = item.values().wahlkreis == valWahlkreis;
            }
            if (valBezirk == '') {
                bezirkFilter = true;
            } else {
                bezirkFilter = item.values().bezirk == valBezirk;
            }
            return parteiFilter && wahlkreisFilter && bezirkFilter;
        });
        abgeordnetenListe.update();

    }

    /* Routenplaner */
    var googleDirURL = "https://www.google.at/maps/dir/";
    $(document).on("keydown", ".ttgAnreiseInput", function(e) {
        if (e.which == 13) {
            routingURL1 = googleDirURL + this.value + "/48.30419615371807,14.285146138843006";
            window.open(routingURL1, "_blank");
        }
    });
    $(document).on("click", ".ttgGoogleDirBtn", function() {
        var inputObj = $(this).prev();
        routingURL2 = googleDirURL + inputObj.value + "/48.30419615371807,14.285146138843006";
        window.open(routingURL2, "_blank");
    });

    /* OÖVV Routenplaner */
    $(document).on("click", ".ttgOOEVVDirBtn", function() {
        routingURL = "https://verkehrsauskunft.ooevv.at/?language=de_DE&P=TP&Z=Landhausplatz, 4020 Linz";
        window.open(routingURL, "_blank");
    });

});

function unique(value, index, self) {
    return self.indexOf(value) === index;
}
